import React from "react";

const Checkbox = ({ name, handleClick, isChecked }) => {
  return (
    <input
      id={name}
      name={name}
      type="checkbox"
      onChange={handleClick}
      checked={isChecked}
    />
  );
};

export default Checkbox;
